import type { QuoteType } from 'src/types/miscType'

export const vatIntracomType = ['eu', 'intl']

export const projectTypes = [
	'advertisingProduction',
	'imageAndSound',
	'productionShort',
	'animation',
	'photoProduction',
	'featureFilm',
	'series',
	'360Template',
	'other',
]

export const projectGroupsAssociatedQuoteTypes = {
	advertisingProduction: ['frenchApfp', 'aicp', 'quoteDigital', 'blankQuote'],
	imageAndSound: ['frenchPostProd', 'soundProd', 'blankQuote'],
	productionShort: ['frenchApfp', 'quoteDigital', 'blankQuote'],
	animation: [
		'quoteAnimationAndLiveAction',
		'quoteAnimationOnly',
		'blankQuote',
	],
	photoProduction: ['photoGrid', 'blankQuote'],
	featureFilm: ['cnc5ch', 'blankQuote'],
	series: ['blankQuote'],
	'360Template': ['blankQuote', '360Template'],
	other: [
		'frenchApfp',
		'frenchPostProd',
		'aicp',
		'photoGrid',
		'soundProd',
		'cnc5ch',
		'quoteDigital',
		'quoteAnimationOnly',
		'quoteAnimationAndLiveAction',
		'blankQuote',
		'360Template',
	],
}

export const quoteTypes: QuoteType[] = [
	'frenchApfp',
	'frenchPostProd',
	'aicp',
	'photoGrid',
	'soundProd',
	'cnc5ch',
	'quoteDigital',
	'quoteAnimationOnly',
	'quoteAnimationAndLiveAction',
	'blankQuote',
	'360Template',
]

export const costlineAccFamily = [
	'servicesProvided20',
	'publishingRights10',
	'masterRights20',
	'billOfRights10',
	'billOfRights20',
	'rightMusic',
	'copyRightAndReproduction',
	'servicesProvided10',
	'synchroTradingService',
	'tradingService',
]

export const companyLogoArray = [
	'logoImage',
	'logoImage2',
	'logoImage3',
	'logoImage4',
] as const
